
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46404_93GFpW_459WqpI7E18c010nts1k2tP1WYoz76YS_NYnbrjcMeta } from "/opt/buildhome/repo/pages/[...404].vue?macro=true";
import { default as commitNtxIiwI8swul6QvT0wZQZAVDr9neV9GiMWOJ0ZfMk2YMeta } from "/opt/buildhome/repo/pages/commit.vue?macro=true";
import { default as _91uuid_93Eaug_nm8CxrHo30_n_45RRrZnq6oGNVRKVdyguQmZyUBAMeta } from "/opt/buildhome/repo/pages/detail/[uuid].vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
export default [
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/opt/buildhome/repo/pages/[...404].vue")
  },
  {
    name: "commit",
    path: "/commit",
    component: () => import("/opt/buildhome/repo/pages/commit.vue")
  },
  {
    name: "detail-uuid",
    path: "/detail/:uuid()",
    component: () => import("/opt/buildhome/repo/pages/detail/[uuid].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  }
]